import { call, put, takeLatest } from "redux-saga/effects";
import { DELETE_SERVICE_DEVICE_REQUEST, getModalityDeviceSuccess, getModalitySearchDeviceSuccess, getScheduleDevicesSuccess, getServiceSearchDeviceSuccess, getUserProfileSuccess, GET_MODALITY_DEVICE_FAILURE, GET_MODALITY_DEVICE_REQUEST, GET_MODALITY_SEARCH_DEVICE_FAILURE, GET_MODALITY_SEARCH_DEVICE_REQUEST, GET_SCHEDULE_DEVICES_FAILURE, GET_SCHEDULE_DEVICES_REQUEST, GET_SERVICE_SEARCH_DEVICE_FAILURE, GET_SERVICE_SEARCH_DEVICE_REQUEST, GET_USER_PROFILE_FAILURE, GET_USER_PROFILE_REQUEST, POST_SERVICE_DEVICE_REQUEST, PUT_SERVICE_DEVICE_REQUEST, postServiceDeviceSuccess, POST_SERVICE_DEVICE_FAILURE, getServiceSearchDeviceRequest, PUT_USER_PROFILE_REQUEST, POST_MODALITY_DEVICE_REQUEST, getUserProfileRequest, POST_RESET_PASSWORD_FAILURE, POST_RESET_PASSWORD_REQUEST, PUT_MODALITY_DEVICE_REQUEST, getModalitySearchDeviceRequest } from "../actions/servicesAction";
import { deleteServicesAPICall, getModalityAPICall, getModalitySearchAPICall, getProfileAPICall, getScheduleDeviceAPICall, getServicesSearchAPICall, postForgotPasswordApiCall, postModalitySearchAPICall, postNotificationToSlackAPICall, postProfileAPICall, postResetPasswordApiCall, postServicesAPICall, putModalitySearchAPICall, putProfileAPICall, putServicesAPICall } from "../apis/servicesApi";
import { checkAuthorizationError, clearNotification, dataLoadingNotification, errorNotification, successNotification } from "../utils/notification-helpers";
import AuthService from "../services/AuthService";
import { getModalityOptions } from "../actions/patientAction";
import { POST_FORGOT_PASSWORD_REQUEST, POST_SLACK_PROCEDURES_REQUEST, postForgotPasswordSuccess } from "../actions/authenticationActions";

const auth = new AuthService()

function * getModalityDeviceHandler ({ payload }) {
  try {
    
      const { responseStatus, responseJSON } = yield call(getModalityAPICall, payload)
      if(responseStatus >= 200 && responseStatus < 300){
        yield put(getModalityDeviceSuccess(responseJSON))
        yield put(getModalityOptions(responseJSON))
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }

  } catch (e) {
    console.error(e)
    yield put({
      type: GET_MODALITY_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * getModalitySearchDeviceHandler ({ payload }) {
  try {
      const { responseStatus, responseJSON } = yield call(getModalitySearchAPICall, payload)
      if(responseStatus >= 200 && responseStatus < 300){
        yield put(getModalitySearchDeviceSuccess(responseJSON))
        yield put(getModalityOptions(responseJSON))
      } else if(responseStatus === 404){
        yield put(getModalitySearchDeviceSuccess([]))
      }

  } catch (e) {
    console.error(e)
    yield put({
      type: GET_MODALITY_SEARCH_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * putModalityDeviceHandler ({ payload }) {
  try {
    const { modalityData } = payload
  
      const { responseStatus, responseJSON } = yield call(putModalitySearchAPICall, modalityData)
      if(responseStatus >= 200 && responseStatus < 300){
        yield put(getModalitySearchDeviceRequest({facility_id: modalityData?.facility_guid}))
      }

  } catch (e) {
    console.error(e)
    yield put({
      type: GET_MODALITY_SEARCH_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * postModalityDeviceHandler ({ payload }) {
  try {
    const { userProfile, facility_id } = payload
    const userData={
      "autho_id":userProfile.autho_id,
      "location":userProfile.location,
      "mobile_number": userProfile?.mobile_number,
      "last_name": userProfile.last_name,
      "middle_name": userProfile.middle_name,
      "first_name": userProfile?.first_name,
      "title": userProfile.title,
      "profile_id": userProfile.id,
      "device": "service 6",
      "modalities": "modality 3",
      "mdl_active": "active",
      "status":"status",
      facility_id: facility_id
    }
      const { responseStatus, responseJSON } = yield call(postModalitySearchAPICall,userData)
      if(responseStatus >= 200 && responseStatus < 300){
        yield put(getModalitySearchDeviceSuccess(responseJSON))
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      } else if(responseStatus === 404){
        yield put(getModalitySearchDeviceSuccess([]))
      }

  } catch (e) {
    console.error(e)
    yield put({
      type: GET_MODALITY_SEARCH_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * postServiceDeviceHandler ({ payload }) {
  try {
    const { afterSuccess } = payload || {}
    const { userBasicInfo } = auth.getProfile()
    const serviceData={
      ...payload,
      autho_id: userBasicInfo?.userGuid,
    }
      const { responseStatus, responseJSON } = yield call(postServicesAPICall, serviceData)
      if(responseStatus >= 200 && responseStatus < 300){
        if(afterSuccess){
          afterSuccess(responseJSON.id)
        }
        // yield put(postServiceDeviceSuccess({profile_id:responseJSON?.profile_id}))
        yield put(getServiceSearchDeviceRequest({ profile_id:responseJSON?.profile_id, facility_id: responseJSON.facility_id}))
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }

  } catch (e) {
    console.error(e)
    yield put({
      type: POST_SERVICE_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * putServiceDeviceHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(putServicesAPICall, payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(postServiceDeviceSuccess({profile_id:responseJSON?.profile_id}))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }

  } catch (e) {
    console.error(e)
    yield put({
      type: POST_SERVICE_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * deleteServiceDeviceHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(deleteServicesAPICall, payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getServiceSearchDeviceRequest({ facility_id: payload.facility_id, profile_id: payload.profile_id}))
      yield put(postServiceDeviceSuccess({profile_id:responseJSON?.profile_id}))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }

  } catch (e) {
    console.error(e)
    yield put({
      type: POST_SERVICE_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getServiceSearchDeviceHandler ({ payload }) {
  try {
      const { responseStatus, responseJSON } = yield call(getServicesSearchAPICall, payload)
      if(responseStatus >= 200 && responseStatus < 300){
        yield put(getServiceSearchDeviceSuccess(responseJSON))
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }else if(responseStatus === 404){
        yield put(getServiceSearchDeviceSuccess([]))
      }

  } catch (e) {
    console.error(e)
    yield put({
      type: GET_SERVICE_SEARCH_DEVICE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getScheduleDeviceHandler ({ payload }) {
  try {
      const { responseStatus, responseJSON } = yield call(getScheduleDeviceAPICall, payload)
      if(responseStatus >= 200 && responseStatus < 300){
        yield put(getScheduleDevicesSuccess(responseJSON))
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_SCHEDULE_DEVICES_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * getProfileHandler () {
  try {
    const { userBasicInfo } = auth.getProfile()
    const userData={
      autho_id: userBasicInfo?.userGuid,
      location: "",
      mobile_number: userBasicInfo?.userPhone,
      last_name: userBasicInfo?.userRealName?.split(' ')[1] || '',
      middle_name: "",
      first_name: userBasicInfo?.userRealName?.split(' ')[0] || '',
      title: ""
    }
    const { responseStatus, responseJSON } = yield call(getProfileAPICall, userBasicInfo.userGuid)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getUserProfileSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    } else {
      const { responseStatus: responseOk, responseJSON: createResponseJSON } = yield call(postProfileAPICall, userData)
      if(responseOk){
        yield put(getUserProfileSuccess([createResponseJSON]))
        const { responseStatus, responseJSON } = yield call(getProfileAPICall, userBasicInfo.userGuid)
        if(responseStatus >= 200 && responseStatus < 300){
          yield put(getUserProfileSuccess(responseJSON))
        } else if(responseStatus === 401){
          throw Error(responseStatus);
        } 
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_USER_PROFILE_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * putProfileHandler ({ payload }) {
  try {
      const { responseStatus, responseJSON } = yield call(putProfileAPICall, payload)
      if(responseStatus >= 200 && responseStatus < 300){
        successNotification("Profile is updated")
        yield put(getUserProfileRequest())
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }
  } catch (e) {
    console.error(e)
    yield put({
      type: GET_SCHEDULE_DEVICES_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * postResetPasswordHandler ({ payload }) {
  try {
    dataLoadingNotification("Sending reset password email")
    const { requestBody } = payload
    const { responseOk, responseJSON } = yield call(postResetPasswordApiCall, requestBody)
    if (responseOk) {
      const { message } = responseJSON
      clearNotification()
      successNotification(message)
    } else {
      clearNotification()
      errorNotification("Unable to send reset email. Please try again.")
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_RESET_PASSWORD_FAILURE,
      message: e.message
    })
  }
}

function * postForgotPasswordSagaHandler ({ payload }) {
  try {
    dataLoadingNotification("Forgot Password Request")
    const data = yield call(postForgotPasswordApiCall, payload)
    if (!data) {
      yield clearNotification();
      yield errorNotification(("Failed to process the forgot password request."), 1.5)
      yield put(postForgotPasswordSuccess(data))
    } else {
      yield clearNotification()
      yield successNotification(("Email has been Sent"), 1.5)
      yield put(postForgotPasswordSuccess(data))
    }
  } catch (e) {
    yield clearNotification();
    console.error('Failed to process the forgot password request.', e)
    yield errorNotification(("Failed to process the forgot password request."), 1.5)
  }
}

function * postNotificationToSlackSagaHandler ({ payload }) {
  try {

  // const slackApiUrl = 'https://slack.com/api/chat.postMessage';
  // const slackApiToken = 'xoxb-14719912678-5612198246212-mXxgw0sEZdrxg9V0jlwpx5Fj';
  // const channelId = 'C05H943V9Q9'; // The ID of the channel you want to send the message to
  // const messageText = 'Hello from React.js!'; // The message you want to send

  // const headers = {
  //   Authorization: `Bearer ${slackApiToken}`,
  //   'Content-Type': 'application/json',
  // };

  // const data = {
  //   channel: channelId,
  //   text: messageText,
  // };
  // yield call(fetch, slackApiUrl, {
  //   method: 'POST',
  //   headers,
  //   body: JSON.stringify(data),
  // });

    // const config = {
    //   method: 'POST',
    //   headers,
    //   body: JSON.stringify(data)
    // }
    // dataLoadingNotification("Forgot Password Request")
    const data = yield call(postNotificationToSlackAPICall, {title: '[Create Organization]:', description: 'The organization already exists', jsonContent: "testing front desk"})
  } catch (e) {
    yield clearNotification();
  }
}

export function * servicesSaga () {
  yield takeLatest(GET_MODALITY_DEVICE_REQUEST, getModalityDeviceHandler)
  yield takeLatest(PUT_MODALITY_DEVICE_REQUEST, putModalityDeviceHandler)
  yield takeLatest(GET_MODALITY_SEARCH_DEVICE_REQUEST, getModalitySearchDeviceHandler)
  yield takeLatest(POST_SERVICE_DEVICE_REQUEST, postServiceDeviceHandler)
  yield takeLatest(DELETE_SERVICE_DEVICE_REQUEST, deleteServiceDeviceHandler)
  yield takeLatest(PUT_SERVICE_DEVICE_REQUEST, putServiceDeviceHandler)
  yield takeLatest(GET_SERVICE_SEARCH_DEVICE_REQUEST, getServiceSearchDeviceHandler)
  yield takeLatest(GET_SCHEDULE_DEVICES_REQUEST, getScheduleDeviceHandler)
  yield takeLatest(POST_MODALITY_DEVICE_REQUEST, postModalityDeviceHandler)
  yield takeLatest(GET_USER_PROFILE_REQUEST, getProfileHandler)
  yield takeLatest(PUT_USER_PROFILE_REQUEST, putProfileHandler)
  yield takeLatest(POST_RESET_PASSWORD_REQUEST, postResetPasswordHandler)
  yield takeLatest(POST_FORGOT_PASSWORD_REQUEST, postForgotPasswordSagaHandler)
  yield takeLatest(POST_SLACK_PROCEDURES_REQUEST, postNotificationToSlackSagaHandler)
}
